import styled from '@emotion/styled';

export const ChartTooltip = styled('div')(({ theme }) => ({
  padding: `${theme.spacing[4]}px ${theme.spacing[8]}px`,
  borderRadius: theme.radius[8],
  backgroundColor: theme.colors.background.overlay,
}));
